import 'nodelist-foreach-polyfill';
import anime from 'animejs/lib/anime.es';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';
import './customSelect.scss';

document.addEventListener('DOMContentLoaded', () => {
  if (window.isMobile.any) return;
  document.querySelectorAll('[data-customSelect]').forEach((SelectItem) => {
    const $SelectItem = $(SelectItem);
    const dropdownContainer = $SelectItem.parents('.input-block__input');

    $SelectItem.select2({
      minimumResultsForSearch: -1,
      dropdownParent: dropdownContainer,
    });

    $SelectItem.on('select2:open', () => {
      const dropdown = dropdownContainer.find('.select2-container.select2-container--open')[1];
      anime.set(dropdown, { opacity: 1 });

      dropdown.classList.remove('show');
      setTimeout(() => {
        dropdown.classList.add('show');
      }, 0);
    });

    $SelectItem.change(() => {
      const event = document.createEvent('Event');
      event.initEvent('input', true, true);
      SelectItem.dispatchEvent(event);
    });
  });
});
